<template lang="pug">
div(class="tw-absolute tw-self-start tw-w-full")
  div(class="tw-relative tw-self-start tw-pt-5 tw-mt-2 tw-w-10/12 tw-mx-auto tw-z-50 ")
    div(class="tw-absolute tw-w-full tw-h-20 tw-z-40" :class="appBarBg")
    div(class="tw-absolute tw-w-full tw-z-50")
      v-row(justify="space-between" align="center" class=" tw-mx-16 ")
        v-col(cols="auto")
          template(v-if="website.logo")
            div(class="theme-f-company-logo")
              v-img(:src="path(website.logo)" contain class="tw-mx-6 tw-rounded-full" :class="logoBg")
          template(v-else)
            span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor
        v-spacer
        v-col(cols="auto")
          v-row(class="tw-font-bold tw-text-sm tw-px-2 ")
            v-col(cols="auto" v-if="website.pages.home.published")
              router-link(:to="{ path: '/website' }")
                span(:class="titleColor" class=" tw-uppercase") {{ website.pages.home.name }}
            v-col(v-if="website.pages.rent.published" cols="auto")
              router-link(:to="{ path: '/website/rent' }")
                span(:class="titleColor" class=" tw-uppercase") {{ website.pages.rent.name }}
            v-col(cols="auto" v-if="website.pages.buy.published")
              router-link(:to="{ path: '/website/sale' }")
                span(:class="titleColor" class=" tw-uppercase") {{ website.pages.buy.name }}
            v-col(cols="auto" v-if="website.pages.about.published")
              router-link(:to="{ path: '/website/about' }")
                span(:class="titleColor" class=" tw-uppercase") {{ website.pages.about.name }}
            v-col(cols="auto" v-if="website.pages.contact.published")
              router-link(:to="{ path: '/website/contact' }")
                span(:class="titleColor" class=" tw-uppercase") {{ website.pages.contact.name }}
</template>
<script>
export default {
  props: {
    appBarBg: {
      type: String,
      default: 'tw-bg-none',
    },
    titleColor: {
      type: String,
      default: 'tw-text-white',
    },
    changeOnScroll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      logoBg: 'tw-shadow-md',
    };
  },
  mounted() {
    if (this.changeOnScroll == true) {
      document.getElementById('website-theme-preview').onscroll = () => {
        this.appBarChangeColor();
      };
    }
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
  methods: {
    appBarChangeColor() {
      if (document.body.scrollTop > 100 || document.getElementById('website-theme-preview').scrollTop > 100) {
        this.appBarBg = ' tw-bg-cyan-darken-3 tw-shadow-lg tw-rounded-full tw-opacity-75';
        this.titleColor = 'tw-text-white';
        this.logoBg = 'tw-rounded-full';
      } else {
        this.appBarBg = 'tw-bg-none';
        this.titleColor = 'tw-text-white';
      }
    },
  },
};
</script>
<style>
.theme-f-company-logo {
  width: 125px;
}
</style>
